'use client'

import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import type { NewsletterFormProps } from './NewsletterForm'
import styles from './NewsletterFormGate.module.scss'

const HIDDEN_ON = '/entradas/newsletters/edit'

// Diferido fuera del bundle inicial: es contenido bajo el pliegue en todas las
// páginas, sin gesto de interacción que lo revele (a diferencia de un widget
// que un clic abre) — ver specs/010-mejora-rendimiento-web/research.md §5.
// `ssr: false` evita que su JS forme parte del render inicial del servidor.
const NewsletterForm = dynamic(
  () => import('./NewsletterForm').then((m) => m.NewsletterForm),
  { ssr: false, loading: () => <div className={styles.skeleton} aria-hidden="true" /> },
)

/**
 * Envuelve el `NewsletterForm` de alta que el layout raíz renderiza en todas las
 * páginas. Se oculta en la página de edición de newsletter, que ya trae su propio
 * formulario — mostrar ambos sería redundante y confuso para el suscriptor.
 */
export function NewsletterFormGate(props: NewsletterFormProps) {
  const pathname = usePathname()
  if (pathname?.startsWith(HIDDEN_ON)) return null
  return <NewsletterForm {...props} />
}
